import { useEffect } from "react"
import { useLocation, useNavigate } from "react-router-dom"

const AgreementGuard = () => {
    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        const redirectToAgreement = () => {
            if (location.pathname === "/agreement/sign") {
                return
            }

            sessionStorage.setItem(
                "agreement_return_url",
                location.pathname + location.search
            )

            navigate("/agreement/sign", {
                replace: true
            })
        }

        window.addEventListener(
            "agreement-required",
            redirectToAgreement
        )

        // На случай если exception произошел до монтирования Guard
        if (
            sessionStorage.getItem("agreement_required") === "1" &&
            location.pathname !== "/agreement/sign"
        ) {
            redirectToAgreement()
        }

        return () => {
            window.removeEventListener(
                "agreement-required",
                redirectToAgreement
            )
        }
    }, [navigate, location.pathname, location.search])

    return null
}

export default AgreementGuard